import { AfterViewInit, Component, inject, ViewChild } from "@angular/core";
import { CommonModule } from "@angular/common";
import { MasterService } from "@frontend/app/serivces/master.service";
import { SanitizerPipe } from "../../pipes/sanitizer.pipe";
import { SVG_ICONS } from "@frontend/app/models/icons";
import { MatDialog } from "@angular/material/dialog";
import { PermissionEditComponent } from "./permission-edit/permission-edit.component";
import { FormsModule } from "@angular/forms";
import { SharedModule } from "@frontend/app/shared/shared.module";
import { MatTableDataSource } from "@angular/material/table";
import { MatPaginator } from "@angular/material/paginator";
import { MatSort } from "@angular/material/sort";
import { tap } from "rxjs";

@Component({
  selector: "app-system-setup",
  imports: [CommonModule, SanitizerPipe, FormsModule, SharedModule],
  templateUrl: "./system-setup.component.html",
  styleUrl: "./system-setup.component.scss",
})
export class SystemSetupComponent implements AfterViewInit {
  private masterService = inject(MasterService);
  private dialog = inject(MatDialog);

  ngAfterViewInit() {
    this.paginator.page.pipe(tap(() => this.getUserMaster(this.paginator.pageIndex + 1, this.paginator.pageSize, this.sort.active, this.sort.direction))).subscribe();
    this.sort.sortChange.subscribe(() => {
      this.getUserMaster(this.paginator.pageIndex + 1, this.paginator.pageSize, this.sort.active, this.sort.direction);
    });
    this.getUserMaster(this.paginator.pageIndex + 1, this.paginator.pageSize, this.sort.active, this.sort.direction);
  }

  //#region variables
  readonly SVG_ICONS = SVG_ICONS;
  userMaster: any;
  filteredUsers: any[] = [];
  displayedColumns: string[] = ["UMID", "UserLoginID", "UserEmail", "UserMobile", "action"];
  dataSource = new MatTableDataSource<any>(); // filteredUsers is your array

  @ViewChild(MatSort) sort!: MatSort;
  @ViewChild(MatPaginator) paginator!: MatPaginator;
  Pagelength = 0;
  //#endregion

  getUserMaster(pageIndex: number, pageSize: number, sortColumn: string, sortDirection: string) {
    const sort = sortColumn ? `ORDER BY ${sortColumn} ${sortDirection}` : "ORDER BY UserLoginID desc";
    this.masterService.getUserList(pageIndex, pageSize, sort,sessionStorage.getItem("selectedCenter")!).subscribe(res => {
      const { Table, TotalCount } = res;
      this.userMaster = Table;
      this.Pagelength = TotalCount;
      this.filteredUsers = [...Table];
      this.dataSource.data = this.filteredUsers;
    });
  }

  onAction(UMID: any) {
    this.dialog.open(PermissionEditComponent, {
      width: "50%",
      height: "40%",
      data: { UMID },
    });
  }
  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value.trim().toLowerCase();
    this.dataSource.filter = filterValue;
  }
}
